import Link from '../../views/ApproveData';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  nextaction: state.shift.assessment.nextaction,
  popwindow: state.shift.status.popwindow
});

const mapDispatchToProps = dispatch => ({
  getuser: memberusername => {
    console.log('I am approbe:');
    //dispatch(actions.getuser(memberusername));
  },
  approveSubmitHandler: memberrole => {
    dispatch(actions.saveapproval(memberrole));
  },

  selectroleHandler: memberrole => {
    dispatch(actions.selectrole(memberrole));
  },

  selectrole: event => {
    dispatch(actions.selectrole({ value: event.target.value }.value));
  },

  approveRejectHandler: () => {
    dispatch(actions.saverejection());
  },

  sendfinalapproveHandler: () => {
    //dispatch(actions.sendfinalapprove());
    dispatch(actions.savefinalapprove());
  }
});

const ApproveData = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default ApproveData;



// WEBPACK FOOTER //
// ./src/components/container/ApproveData/index.js